module.exports = __webpack_public_path__ + "static/media/coxinhamini.8da662f1.webp";